import type { FC } from "react";

import { i18nFilter } from "app/filters/i18nFilter";

import { NoDataIcon, NoDataContainer, NoDataTitle } from "./DeviceDistributionChartNoData.styles";

export const DeviceDistributionChartNoData: FC = () => {
    const translate = i18nFilter();

    return (
        <NoDataContainer>
            <NoDataIcon iconName={"no-data-lab"} />
            <NoDataTitle>{translate("global.nodata.notavilable")}</NoDataTitle>
        </NoDataContainer>
    );
};
